import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BlockableDiv } from '../../../../shared/controls/blockable-div/blockable-div.component';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { Tenant } from '../../../../generated/generated-types';
import { TenantBankAccountLinkListWidgetComponent } from '../tenant-bank-account-link-list-widget/tenant-bank-account-link-list-widget.component';

@Component({
  selector: 'app-formly-tenant-bank-account-link-list',
  templateUrl: './formly-tenant-bank-account-link-list.component.html',
  styleUrls: ['./formly-tenant-bank-account-link-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TenantBankAccountLinkListWidgetComponent,
    BlockableDiv,
    ButtonModule,
    TooltipModule,
    TranslatePipe,
  ]
})
// THIS COMPONENT IS NOT TESTED - SINCE IT IS NOT IN USE RIGHT NOW
export class FormlyTenantBankAccountLinkListComponent extends FieldType<FieldTypeConfig> implements OnInit {

  tenantId: string;

  isSaving: boolean = false;

  // @ViewChild('addEditBankAccountWidgetList')
  // addEditBankAccountWidgetList: BankAccountListWidgetComponent;

  cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  constructor() { super(); }

  ngOnInit(): void {
    if (this.model) {
      this.tenantId = this.model['tenantId']; // The key is comming from the formly field definition[fallbacks]
    }

    // this.formControl.valueChanges.subscribe((model: string) => {
    //   let tenantId = model;
    //   if (this.tenantId != tenantId) {
    //     this.tenantId = tenantId;
    //     this.cdRef.detectChanges();
    //   }
    // })
  }

  checkIfCanSave() {
    let component = this.options.formState.detailComponent as BaseDetailComponent<Tenant>;
    return component.detailForm.invalid;
  }

  async saveToUnlockEditMode() {

    //Other options would be to use the service, but special overwrite in the component wont be used then

    let component = this.options.formState.detailComponent as BaseDetailComponent<Tenant>;
    if (!component) {
      console.error("No detail component found to save");
      return;
    }

    this.isSaving = true;
    this.cdRef.detectChanges();

    await component.save();

    this.isSaving = false;
    this.cdRef.detectChanges();
  }

}
